// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CountDown_main__4rPJL {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  background-color: var(--color-fash-primary-4);
  padding: 2rem;
  margin: 2rem;
}
@media only screen and (max-width: 50em) {
  .CountDown_main__4rPJL {
    padding: 2rem 1rem;
    flex-direction: column;
    align-items: center;
  }
}
.CountDown_main__red__Z-hRZ {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  background-color: var(--color-error);
  color: var(--color-white);
  padding: 2rem;
  margin-bottom: 2rem;
}
@media only screen and (max-width: 50em) {
  .CountDown_main__red__Z-hRZ {
    padding: 2rem 1rem;
    flex-direction: column;
    align-items: center;
  }
}

.CountDown_banner__CNbUR {
  position: absolute;
  bottom: 2rem;
  width: 90%;
  box-sizing: border-box;
  border-radius: 1rem;
  padding: 1rem;
  background-color: var(--color-white);
}
.CountDown_banner__beside__C-tYo {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}
@media only screen and (max-width: 81.25em) {
  .CountDown_banner__beside__C-tYo {
    grid-template-columns: 1fr;
  }
}
.CountDown_banner__icon__XgfjK {
  height: 1.7rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/CountDown/CountDown.module.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,6CAAA;EACA,aAAA;EACA,YAAA;AADF;AAGE;EAVF;IAWI,kBAAA;IACA,sBAAA;IACA,mBAAA;EAAF;AACF;AAEE;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,oCAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AAAJ;AAEI;EAXF;IAYI,kBAAA;IACA,sBAAA;IACA,mBAAA;EACJ;AACF;;AAGA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,oCAAA;AAAF;AAEE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAAJ;AAEI;EALF;IAMI,0BAAA;EACJ;AACF;AAEE;EACE,cAAA;AAAJ","sourcesContent":["@import \"../variables/breakpoints\";\n\n.main {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  background-color: var(--color-fash-primary-4);\n  padding: 2rem;\n  margin: 2rem;\n\n  @media only screen and (max-width: $bp-800) {\n    padding: 2rem 1rem;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  &__red {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1rem;\n    background-color: var(--color-error);\n    color: var(--color-white);\n    padding: 2rem;\n    margin-bottom: 2rem;\n\n    @media only screen and (max-width: $bp-800) {\n      padding: 2rem 1rem;\n      flex-direction: column;\n      align-items: center;\n    }\n  }\n}\n\n.banner {\n  position: absolute;\n  bottom: 2rem;\n  width: 90%;\n  box-sizing: border-box;\n  border-radius: 1rem;\n  padding: 1rem;\n  background-color: var(--color-white);\n\n  &__beside {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1rem;\n\n    @media only screen and (max-width: $bp-1300) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  &__icon {\n    height: 1.7rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `CountDown_main__4rPJL`,
	"main__red": `CountDown_main__red__Z-hRZ`,
	"banner": `CountDown_banner__CNbUR`,
	"banner__beside": `CountDown_banner__beside__C-tYo`,
	"banner__icon": `CountDown_banner__icon__XgfjK`
};
export default ___CSS_LOADER_EXPORT___;
